import Pdf from "./icons/pdf";
import Trash from "./icons/trash";

type FileDisplayProps = {
  file: File;
  removeFile: (file: File) => void;
};

const FileDisplay = (props: FileDisplayProps) => {
  const removeFile = props.removeFile;
  const file = props.file;
  return (
    <div className="w-full relative p-6 border bg-white shadow-md rounded-lg my-8">
      <div className="flex items-center gap-2">
        <Pdf className="h-6 w-6" />
        <div className="flex-grow">{file.name}</div>
        <button
          className="absolute -top-4 -right-4 h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            removeFile(file);
          }}
        >
          <Trash className="h-6 w-6" />
        </button>
      </div>
    </div>
  );
};

export default FileDisplay;
